import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../UI/Layout/DashboardLayout";
import Title from "../../../UI/Text/Title";
import AdvanceDataTable from "../../../UI/Table/AdvanceDataTable";
import axios from "axios";
import { AGENT_BILLING } from "../../../UI/Table/ColumnConst";


const AgentBilling = () => {
  const lStorage = JSON.parse(localStorage.getItem("login"));
  const user_id = lStorage?.user?.userId;
  const token = lStorage?.token;

  const [AgentBillingData, setAgentBillingData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const totalActiveAgents = AgentBillingData.filter(agent => agent.status === "Active").length;

  useEffect(() => {
    const fetchAgents = async () => {
      setIsLoading(true);
      try {
        const response = await axios.post("https://stagnapi.authkey.io/api/agent_management", {
          user_id,
          token,
          method: "agent_list",
        });


        if (response.data && Array.isArray(response.data.data)) {  
          const formatted = response.data.data.map((agent, index) => ({
            id: index + 1,
            name: agent.name,
            created: agent.Created,
            expiryDate: agent.Expiry_Date,
            autoRenew: agent.auto_renew_status === 1 ? "Yes" : "No",
            status: agent.is_active === 1 ? "Active" : "Inactive",
          }));

          setAgentBillingData(formatted);
        } else {
          setError("No data found.");
        }
      } catch (err) {
        setError("");
      } finally {
        setIsLoading(false);
      }
    };

    fetchAgents();
  }, [user_id, token]);

  useEffect(() => {
    console.log("Agent Billing Data:", AgentBillingData); 
  }, [AgentBillingData]);

  return (
    <DashboardLayout>
      <main className="content">
        <div className="container-fluid p-0">

          <div className="row">
            <Title>Agent Billing Details</Title>

            <div className="d-flex justify-content-end align-items-center mb-3" style={{ gap: "10px" }}>
              {!isLoading && AgentBillingData.length > 0 && (
                <div
                  className="btn btn-primary btn-sm fw-bold"
                  style={{
                    pointerEvents: "none", 
                  }}
                >
                  Total Active Agents: {totalActiveAgents}
                </div>
              )}

              <a href="https://agent.authkey.io/administration/create-agent"
                target="_blank"
                rel="noopener noreferrer"
                >
                <button className="btn btn-primary btn-sm fw-bold">
                  Add Agent
                </button>
              </a>
            </div>
          </div>


          {error && <p style={{ color: "red" }}>{error}</p>}


          {AgentBillingData.length === 0 ? (
            <p>No data available</p>
          ) : (
            <AdvanceDataTable
              tableCell={AGENT_BILLING}
              tableData={AgentBillingData}
              isLoading={isLoading}
              pagination={true}
            />
          )}
        </div>
      </main>
    </DashboardLayout>
  );
};

export default AgentBilling;
